import './styles/index.css';
import './styles/global.css';
import './styles/indexMobile.css';

import {
  BrowserRouter as Router,
  useRoutes,
} from "react-router-dom";


import Login from './views/LoginView';
import Dashboard from './views/DashboardView';
import DashboardDep from './views/DashboardDepView';
import Areas from './views/AreasView';
import Usuarios from './views/UsuariosView';
import Orientacion from './views/OrientacionView';
import Canalizacion from './views/CanalizacionView';
import ActaCircunstanciada from './views/ActaCircunstanciadaView';
import Localidades from './views/Localidades';
import Titulos from './views/TitulosView';
import Victimas from './views/VictimasView';
import SolicitudesVictimas from './views/SolicitudesVictimasView';
import Peticiones from './views/PeticionesView';
import PeticionesVictimasView from './views/PeticionesVictimasView';
import DelitosView from './views/DelitosView';
import HeaderComponent from './components/header_component';
import Footer from './components/footer_component';
import Error500 from './components/error_View';
import { useState } from "react";
import { Menu } from "./components/menu_component"
import { GlobalContextProvider } from './context/global_context';
import { NotificacionContextProvider } from './context/notificacion_context';
import NotificacionUi from "./components/iu/notificacion_ui";
import PrivateRoute from './services/privateRoute';
import PrivateRouteDep from './services/privateRouteDep';
import PrivateRouteUser from './services/privateRouteUser';
import PrivateRouteReg from './services/privateRouteReg';
import PrivateRouteApp from './services/privateRouteApp';
import CrearFudView from './views/crearFudView';
import Unauthtorized from './components/Unauthorized';


const RouterApp = () => {

  let routes = useRoutes([

    { path: "/login", element: <Login /> },
    // { path: "/consulta-peticion", element: <PeticionConsultaView /> },
    // { path: "/crear-peticion", element: <CrearPeticionView /> },
    // { path: "/aciudadana", element: <InformacionPublicaView /> },
    // { path: "/firmas", element: <PrivateRoute> <Firmas /> </PrivateRoute> },
    // { path: "/firmaUser", element: <PrivateRouteUser><FirmaUser /></PrivateRouteUser> },
    // { path: "/inicioUser", element: <PrivateRouteUser><DashboardUser /></PrivateRouteUser> },
    // { path: "/folios", element: <PrivateRoute> <Folios /> </PrivateRoute> },
    // { path: "/ciudadanos", element: <PrivateRoute> <Ciudadanos /> </PrivateRoute> },
    // { path: "/ciudadanosUsuario", element: <PrivateRouteUser><CiudadanosUser /></PrivateRouteUser> },
    // { path: "/solicitudCiudadano/:id", element: <PrivateRoute> <SolicitudCiudadano /> </PrivateRoute> },
    // { path: "/solicitudCiudadanoUsuario/:id", element: <PrivateRouteUser><SolicitudCUser /></PrivateRouteUser> },
    // { path: "/peticionesCiudadano/:id", element: <PrivateRoute> <PeticionesCiudadano /> </PrivateRoute> },
    // { path: "/peticionesCiudadanoUsuario/:id", element: <PrivateRouteUser><PeticionesCUser /></PrivateRouteUser> },
    // { path: "/solicitudes", element: <PrivateRoute> <Solicitudes /> </PrivateRoute> },
    // { path: "/solicitudesUsuario", element: <PrivateRouteUser><SolicitudesUser /></PrivateRouteUser> },
    { path: "/crear-fud", element: <PrivateRouteUser><CrearFudView /></PrivateRouteUser> },
    { path: "/crear-fud/:id", element: <PrivateRouteUser><CrearFudView /></PrivateRouteUser> },
    { path: "/inicio", element: <PrivateRouteReg><Dashboard /> </PrivateRouteReg> },
    { path: "/inicioDep", element: <PrivateRouteDep><DashboardDep /></PrivateRouteDep> },
    { path: "/victimas", element: <PrivateRouteUser><Victimas /></PrivateRouteUser> },
    { path: "/solicitudesVictimas", element: <PrivateRouteApp><SolicitudesVictimas/> </PrivateRouteApp>},
    { path: "/solicitudesVictimas/solicitud/:applicationId", element: <PrivateRouteUser> <SolicitudesVictimas/> </PrivateRouteUser> },
    { path: "/solicitudesVictimas/:victimId", element: <PrivateRouteUser> <SolicitudesVictimas/> </PrivateRouteUser> },
    { path: "/solicitudesVictimas/:status_group", element: <PrivateRouteReg> <SolicitudesVictimas/> </PrivateRouteReg> },
    { path: "/peticiones", element: <PrivateRouteDep> <Peticiones /> </PrivateRouteDep> },
    { path: "/peticionesVictimas", element: <PrivateRouteDep> <PeticionesVictimasView /> </PrivateRouteDep> },
    { path: "/peticionesVictimas/:applicationId", element: <PrivateRouteUser> <PeticionesVictimasView/> </PrivateRouteUser> },
    { path: "/peticionesVictimas/:status_group", element: <PrivateRouteDep> <PeticionesVictimasView/> </PrivateRouteDep> },
    // { path: "/peticionesDep", element: <PrivateRouteDep><PeticionesDep /></PrivateRouteDep> },
    // { path: "/peticionesUsuario", element: <PrivateRouteUser><PeticionesUser /></PrivateRouteUser> },
    // { path: "/audiencia", element: <PrivateRoute><Audiencia /></PrivateRoute> },
    // { path: "/audienciaUser", element: <PrivateRouteUser><AudienciaUser /></PrivateRouteUser> },
    // { path: "/fuentesSolicitud", element: <PrivateRoute> <FuentesDeSolicitud /> </PrivateRoute> },
    // { path: "/tiposCargo", element: <PrivateRoute> <TipoCargo /> </PrivateRoute> },
    // { path: "/geolocalizacion", element: <GeolocalizacionView /> },
    { path: "/areas", element: <PrivateRoute> <Areas/> </PrivateRoute> },
    { path: "/usuarios", element: <PrivateRoute> <Usuarios /> </PrivateRoute> },
    { path: "/orientacion", element: <PrivateRouteUser><Orientacion/></PrivateRouteUser> },
    { path: "/canalizacion", element: <PrivateRouteUser><Canalizacion /></PrivateRouteUser> },
    { path: "/ActaCircunstanciada", element: <PrivateRouteUser><ActaCircunstanciada /></PrivateRouteUser> },
    { path: "/titulos", element: <PrivateRoute> <Titulos /> </PrivateRoute> },
    { path: "/localidades", element: <PrivateRoute> <Localidades /> </PrivateRoute> },
    { path: "/delitos", element: <PrivateRoute> <DelitosView /> </PrivateRoute> },
    { path: "/", element: <Login /> },
    { path: "/*", element: <Error500 /> },
    { path: "/unauthorized", element: <Unauthtorized /> },

  ]);
  return routes;
}



function App() {

  const [state, setState] = useState({
    showMenu: false
  })



  return (
    <div className="App">
      <GlobalContextProvider>
        <NotificacionContextProvider>
          <main id="mainContent">

            <Router>
              <HeaderComponent onClose={() => { setState({ ...state, showMenu: true }) }} />
              {state.showMenu ?
                <Menu onClose={() => { setState({ ...state, showMenu: false }) }} />
                :
                null
              }
              <NotificacionUi />
              <div className='bg-rosaClarito bk-img mainContent' >
                <RouterApp />
              </div>
              <Footer />
              <div className='backgrounPlaca w-100 '></div>
            </Router>

          </main>

        </NotificacionContextProvider>
      </GlobalContextProvider >
    </div>
  );
}

export default App;